export const teachers = [
  {
    name: {
      zh: '教授',
      en: 'Professors',
    },
    count: 2,
  },
  {
    name: {
      zh: '副教授',
      en: 'Assistant Professors',
    },
    count: 27,
  },
  {
    name: {
      zh: '講師',
      en: 'Lecturers',
    },
    count: 54,
  },
  {
    name: {
      zh: '旅業及酒店業學校輔導員',
      en: 'Instructors',
    },
    count: 34,
  },
]

export const staffs = [
  {
    name: {
      zh: '全職教員',
      en: 'Academic staff',
    },
    count: 117,
  },
  {
    name: {
      zh: '酒店業專業培訓人員',
      en: 'Hospitality occupational training staff',
    },
    count: 35,
  },
  {
    name: {
      zh: '行政及其他人員',
      en: 'Administrative and other staff',
    },
    count: 193,
  },
]
